export default __webpack_public_path__ + "static/media/EditIcon.d55d2800.svg";